import { forbiddenDescDesktopText, forbiddenDescMobileText, forbiddenDescText, forbiddenLoggedIn } from 'Const/forbidden/text';

const getDescriptionText = (isWrongView, isMobile) => {
  if (isWrongView) return isMobile ? forbiddenDescMobileText : forbiddenDescDesktopText;
  return `${forbiddenDescText} ${forbiddenLoggedIn}`;
};

export default getDescriptionText;
